module.exports = {"id":"dp3_3l3q5","text":"Copyright and licences","instructions":"What is a cautious approach when sharing digital content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l3q5-a1","text":"Check licence terms first","score":3.7},{"id":"dp3_3l3q5-a2","text":"Assume fair use applies","score":1.3},{"id":"dp3_3l3q5-a3","text":"Rely on platform defaults","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l3q5.json
// module id = 1164
// module chunks = 41